import { memo } from 'react'
import { Flex, Text } from '@backyard-ui/core'

interface DividerProps {
  text?: string
}

const Divider = ({ text }: DividerProps) => {
  if (!text) {
    return <div className="w-full h-px bg-black-alpha-300" />
  }

  return (
    <Flex align="center" wrap="nowrap" className="w-full my-4 gap-2">
      <div className="flex-1 h-px bg-black-alpha-300" />
      <Text size="sm" color="gray-600">
        {text}
      </Text>
      <div className="flex-1 h-px bg-black-alpha-300" />
    </Flex>
  )
}

export default memo(Divider)
